import { ItemList } from 'orm'
  
class AdminEditableEmailCustomParameterList extends ItemList {
    getEntityKey() {
        return "admin/editable_email_custom_parameter"
    }
}

export const adminEditableEmailCustomParameterList = new AdminEditableEmailCustomParameterList("admin_editable_email_custom_parameter__default")
